import React, { createRef, useCallback, useEffect, useRef, useState } from "react";
import { RichText, Link, Text } from "@sitecore-jss/sitecore-jss-react";
import _ from "lodash";
import gsap from 'gsap';
import Videojs from "../video-js";
import Image from "../../elements/image";
import Icon from "../../elements/icon";
import Loader from "../../elements/loader";
import WorkMedia from "./workMedia";
import classNames from "classnames"
import { gtag } from "../../utils";
import { mobileIs, loadScrollMagic } from "../../utils/siteUtils";
import "./style.scss";
const CoclubModels = (props) => {;
    let { index, swiperData, activeSlide, isAR, page } = props;
    let { about, works, aboutTxt, workTxt } = swiperData.fields.model.fields;
    let { video, videoMobile, image, imageMobile } = works.fields;
    const videoNode = useRef(null);
    const rootEl = useRef(null);
    const firstEl = useRef(null);
    const aboutEl = useRef(null);
    const workEl = useRef(null);
    const designEl = useRef(null);
    const headImgEl = useRef(null);
    const [activeTab, setActiveTab] = useState(0);
    const [maskShow, setMaskShow] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [isSafari, setIsSafari] = useState(false);
    const [loadingImgLength, setLoadingImgLength] = useState(1);
    const [loadedImgIds, setLoadedImgIds] = useState({});
    const workListLength = works.fields.workList.length;
    const isMobile = mobileIs();
    let videoOptions = 
        (!isMobile && video && video.value) || (isMobile && videoMobile && videoMobile.value)
        ? {
            sources: [
            {
                src: isMobile ? videoMobile.value.src : video.value.src,
                type: isMobile ? videoMobile.value.mimeType : video.value.mimeType
            }
            ],
            poster: isMobile ? imageMobile.value.src : image.value.src,
            videoTitle: '',
            autoplay: isMobile? false : true,
            loop:true,
            controls: false,
            muted: true
        }: null;
    const nextItem = () => {
        gtag('event', 'Component_info', {
          'component_name': 'CoclubModels',
          'page_title': page?.name
        });
        setActiveTab(0)
        // videoNode.current && videoNode.current.player.pause()
        if(isAR){
            props.next && props.prev();
        }else{
            props.next && props.next();
        }
    };
    const prevItem = () => {
        gtag('event', 'Component_info', {
          'component_name': 'CoclubModels',
          'page_title': page?.name
        });
        setActiveTab(0)
        // videoNode.current && videoNode.current.player.pause()
        if(isAR){
            props.prev && props.next();
        }else{
            props.prev && props.prev();
        }
    };
    const close = () => {
        gtag('event', 'Component_info', {
          'component_name': 'CoclubModels',
          'page_title': page?.name
        });
        props.prev && props.close();
        document.getElementsByTagName('html')[0].className = '';
    }
    const loading = (id) => {
        let newData = loadedImgIds;
        newData[id] = id;
        setLoadedImgIds(newData);
        if( Object.keys(loadedImgIds).length == loadingImgLength ){
            let winHeight = window.innerHeight || document.documentElement.clientHeight;
            let dom = workEl.current.getBoundingClientRect();
            if( Math.abs(dom.bottom) > dom.height-winHeight ){
                setLoadingImgLength(loadingImgLength+3)
            }
        }
    }
    const handleScroll = function(){
        let winHeight = window.innerHeight || document.documentElement.clientHeight;
        if(activeTab ==0 && workEl.current){
            if(workEl.current.getBoundingClientRect().y < 50 ){
                setMaskShow(false)
            }else{
                setMaskShow(true)
            }
            let dom = workEl.current.getBoundingClientRect();
            if( Math.abs(dom.bottom) > dom.height-winHeight ){
                var arr = Object.keys(loadedImgIds); 
                if(arr.length == loadingImgLength){
                    setLoadingImgLength(loadingImgLength+3)
                }
            }
        }
    }
	useEffect(() => {
        if((/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)) && isMobile){
            setIsSafari(true)
        }
        if(index == activeSlide-1 && !isMobile){
            setTimeout(v=>{
                videoNode.current && videoNode.current.player.play()
            },10)
        }
        rootEl.current.removeEventListener("scroll", handleScroll);
        rootEl.current.addEventListener("scroll", handleScroll);
        return () => {
            rootEl.current.removeEventListener("scroll", handleScroll);
        };
    }, [activeSlide,loadedImgIds]);
	useEffect(() => {
        if(activeTab==0){
            let ScrollMagic, controller, scene,tl;
            ScrollMagic = loadScrollMagic();
            tl = gsap.timeline();
            tl.to(
              firstEl.current,
              {
                opacity: 0
              }
            )
            controller = new ScrollMagic.Controller();
            scene = new ScrollMagic.Scene({
              triggerElement: firstEl.current,
              triggerHook: 0,
              duration: isMobile? firstEl.current.getBoundingClientRect().width : firstEl.current.getBoundingClientRect().width/3
            })
            .setTween(tl)
            .addTo(controller);
            if(index == activeSlide-1 && !isMobile && activeTab==0){
                setTimeout(v=>{
                    videoNode.current && videoNode.current.player.play()
                },10)
            }
        }
    }, [activeTab]);
    const changeTab = (number) =>{
        gtag('event', 'Component_info', {
          'component_name': 'CoclubModels',
          'page_title': page?.name
        });
        setActiveTab(number)
        document.getElementById("coclubModel").scrollTo(0, 0);
    }
    return (
        <div className={classNames("c-coclub-models-grid grid",{safari:isSafari})}>
            <div className="c-coclub-models grid-story" id="coclubModel" ref={rootEl}>
                <div className="c-coclub-models-content" >
                    { workTxt.value && aboutTxt.value &&
                        <div className={classNames("c-coclub-models-tabs")} >
                            <a onClick={()=>{changeTab(0)}} className={classNames({'active':activeTab === 0})} >{workTxt.value}</a>
                            <a onClick={()=>{changeTab(1)}} className={classNames({'active':activeTab === 1})} >{aboutTxt.value}</a>
                        </div>
                    }
                    { works && activeTab === 0 &&
                        <div className={classNames("c-coclub-models-work",{show: activeTab === 0})} id={`work${index}`} ref={workEl}>
                            <div className="c-coclub-models-work-first">
                                <div className="media">
                                    { videoOptions &&
                                        <Videojs ref={videoNode} {...videoOptions} />
                                    }
                                    { !videoOptions &&
                                        <Image className="img" { ... isMobile ? works.fields.imageMobile.value : works.fields.image.value} />
                                    }
                                </div>
                                <div className="c-coclub-models-work-first-other" ref={firstEl}>
                                    <div className="content show">
                                        { ((isMobile && works.fields.titleMobile) || (!isMobile && works.fields.title)) &&
                                            <div className="content-title">
                                                <RichText tag="div" className={"title type-h1"} field={isMobile ? works.fields.titleMobile : works.fields.title} />
                                                <span>{works.fields.titleIcon.value}</span>
                                            </div>
                                        }
                                        { ((isMobile && works.fields.contentMobile) || (!isMobile && works.fields.content)) &&
                                            <RichText tag="div" className={"des"} field={isMobile ? works.fields.contentMobile : works.fields.content} />
                                        }
                                    </div>
                                    <div className="mask show"></div>
                                </div>
                            </div>
                            <div className="c-coclub-models-work-list">
                            { index == activeSlide-1 && works.fields.workList.map((item, i) => (
                                <div key={i}>
                                    <WorkMedia data={item} showLength={loadingImgLength} index={i} loading={loading}/>
                                </div>
                            ))}
                            </div>   
                            { loadingImgLength < workListLength && 
                                <Loader />
                            }
                        </div>
                    }
                    {about&&activeTab==1 &&
                    <div className="grid aboutGrid">
                        <div className={classNames('c-coclub-models-about',{show: activeTab === 1})} id={`about${index}`} ref={aboutEl}>
                            <div className="c-coclub-models-about-header">
                                <img className="headImg" src={about.fields.headImage.value.src}/>
                                <img ref={designEl} width={about.fields.image.value.width} height={about.fields.image.value.height} className="design" src={about.fields.image.value.src}/>
                            </div>
                            {((isMobile && about.fields.workNameMobile) || (!isMobile && about.fields.workName)) &&
                                <RichText tag="div" className={"c-coclub-models-about-name"} field={isMobile?about.fields.workNameMobile:about.fields.workName} />
                            }
                            {about.fields.socialItems != null && about.fields.socialItems.length > 0 &&
                                <div className={"socialMedia"} >
                                {about.fields.socialItems.map((item, index) => {
                                    return (
                                    <Link key={index} field={item.fields.link}>
                                        {item.fields.iconName && <Icon icon={{ ...item.fields.iconName.value }} />}
                                    </Link>
                                    );
                                })}
                                </div>
                            }     
                            {(about.fields.content || about.fields.contentMobile) && 
                                <RichText tag="div" className={"c-coclub-models-about-des"} field={isMobile ? about.fields.contentMobile : about.fields.content} />
                            }
                            {(about.fields.copyright || about.fields.copyrightMobile) && 
                                <RichText tag="div" className={"c-coclub-models-about-copyright"} field={isMobile ? about.fields.copyrightMobile : about.fields.copyright} />
                            }
                        </div>
                    </div>
                    }
                </div>
                <div onClick={close} className="close">
                    <Icon name="Close"/>
                </div>
                {activeTab === 0 &&
                    <>
                    
                        <Icon name="SwiperLeft" onClick={prevItem} className="c-coclub-models__left" />
                        <Icon name="SwiperRight" onClick={nextItem} className="c-coclub-models__right" />
                    </>
                }
            </div>
        </div>
    );
};
export default CoclubModels;
